document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('#macy-container');
  if (!container) return;

  const macyInstance = Macy({
    container: '#macy-container',
    margin: 30,
    columns: 4,
    trueOrder: false,
    waitForImages: false, // handling images manually
    breakAt: {
      1200: 3,
      990: 2,
      640: 1,
    },
  });

  // === Scroll Animation with Intersection Observer ===
  const animatedItems = container.querySelectorAll('.macy-item');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');

        // Trigger Macy recalc after animation
        macyInstance.recalculate(true);

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
  });

  animatedItems.forEach((item) => observer.observe(item));
});


